/* 
*  Created by SGiri 03/19/2018
*/

import { Injectable, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { Router } from '@angular/router';
import { environment } from '~environment'

@Injectable()
export class CommonService {

  environment: string;
  userRole: string = null;
  isActive: EventEmitter<boolean>;

  constructor(private router: Router, private dialog: MatDialog) {
    environment.production ? this.environment = 'UAT' : this.environment = 'DEV';
    this.isActive = new EventEmitter<boolean>();
  }

  public setEnvironment(environment: string) {
    this.environment = environment;
  }

  public getEnvironment() {
    return this.environment;
  }

  public showDialog(data) {

    let dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '900px',
      autoFocus: false,
      data: data,
      disableClose: true
    });
  }

  public showError(err: any) {
    let message;
    if (!err.error) {
      message = err.message;
    } else if (err.error.message) {
      message = err.error.message;
    } else {
      message = err.error;
    }

    let data = {
      isError: true,
      message: message
    }
    this.showDialog(data);
  }

  public reload() {
    this.router.routeReuseStrategy.shouldReuseRoute = function (f, c) {
      return false;
    }
    this.router.navigated = false;
    this.router.navigate([this.router.url])
  }

  public navigate(url: string) {
    this.router.navigate([url])
  }

  public isHidden() {
    return (this.userRole == 'ADMINISTRATOR') ? false : true;
  }

  showLoader() {
    this.isActive.emit(true);
  }

  hideLoader() {
    this.isActive.emit(false);
  }
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/util/common.service.ts